import ltInstantPromoPopup from 'html/addon/lt-instant-promo-popup.html';
import App from 'app/app.js';
import 'app/directive/LtInstantPromoPopupCtrl.js';

function LtInstantPromoPopupDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      selected: '=',
      addClick: '&',
      goCart: '&',
      popAction: '&',
      personalizeClick: '&',
      navPrev: '&',
      navNext: '&',
      next: '=',
      prev: '=',
      discount: '=',
      showHolidayBanner: '='
    },
    template: ltInstantPromoPopup,
    controller: 'LtInstantPromoPopupCtrl',
    controllerAs: 'instantpromopopup'
  };
}

App.directive('ltInstantPromoPopup', [LtInstantPromoPopupDirective]);
